// Viti Vinci — Editions carousel paginator.
// Hooks up the < > arrow buttons to scroll the product strip by one card width.

(function () {
  function init(section) {
    const carousel = section.querySelector('[data-vv-edt-carousel]');
    const prev = section.querySelector('[data-vv-edt-prev]');
    const next = section.querySelector('[data-vv-edt-next]');
    if (!carousel) return;

    function step() {
      const first = carousel.firstElementChild;
      if (!first) return 0;
      const cardW = first.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(carousel).columnGap || getComputedStyle(carousel).gap || 0) || 0;
      return cardW + gap;
    }

    function update() {
      if (!prev || !next) return;
      // 2px tolerance — sub-pixel rounding can leave scrollWidth slightly
      // less than clientWidth even when there's clearly room to scroll.
      const max = carousel.scrollWidth - carousel.clientWidth;
      prev.toggleAttribute('disabled', carousel.scrollLeft <= 1);
      next.toggleAttribute('disabled', carousel.scrollLeft >= max - 1);
    }

    prev?.addEventListener('click', (e) => {
      e.preventDefault();
      carousel.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next?.addEventListener('click', (e) => {
      e.preventDefault();
      carousel.scrollBy({ left: step(), behavior: 'smooth' });
    });

    carousel.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(carousel);
    // Re-run after images load — image dimensions can change scrollWidth.
    window.addEventListener('load', update);
    // Initial run + a deferred pass for late layout (fonts, images, hydration).
    update();
    requestAnimationFrame(update);
    setTimeout(update, 250);
  }

  document.querySelectorAll('[data-vv-editions]').forEach(init);
})();
